var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#0D6EFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_11622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6073 14.6937H20.9373C20.8626 14.1617 20.704 13.695 20.4613 13.2937C20.2186 12.883 19.9153 12.5424 19.5513 12.2717C19.1873 12.001 18.772 11.7957 18.3053 11.6557C17.8386 11.5157 17.344 11.4457 16.8213 11.4457C16.056 11.4457 15.3746 11.5857 14.7773 11.8657C14.1893 12.1364 13.6946 12.5097 13.2933 12.9857C12.9013 13.4617 12.6026 14.0217 12.3973 14.6657C12.192 15.3004 12.0893 15.9817 12.0893 16.7097C12.0893 17.4377 12.1826 18.119 12.3693 18.7537C12.5653 19.3884 12.8546 19.939 13.2373 20.4057C13.62 20.8724 14.1006 21.241 14.6793 21.5117C15.258 21.773 15.9346 21.9037 16.7093 21.9037C17.988 21.9037 18.996 21.5537 19.7333 20.8537C20.4706 20.1537 20.9046 19.1737 21.0353 17.9137H19.7053C19.6773 18.3244 19.5933 18.707 19.4533 19.0617C19.3133 19.4164 19.1173 19.7244 18.8653 19.9857C18.6226 20.2377 18.3286 20.4384 17.9833 20.5877C17.6473 20.7277 17.26 20.7977 16.8213 20.7977C16.224 20.7977 15.7106 20.6857 15.2813 20.4617C14.852 20.2377 14.4973 19.939 14.2173 19.5657C13.9466 19.183 13.746 18.7397 13.6153 18.2357C13.4846 17.7224 13.4193 17.181 13.4193 16.6117C13.4193 16.089 13.4846 15.585 13.6153 15.0997C13.746 14.6144 13.9466 14.185 14.2173 13.8117C14.4973 13.429 14.8473 13.1257 15.2673 12.9017C15.6966 12.6777 16.21 12.5657 16.8073 12.5657C17.5073 12.5657 18.1093 12.743 18.6133 13.0977C19.1266 13.4524 19.458 13.9844 19.6073 14.6937Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03906,
    y: 1.17969,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.539062 0.679688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon4);
export default __webpack_public_path__ + "static/media/user_icon_4.23ad1ee1dcb8f5d477622b8297e89ede.svg";
export { ForwardRef as ReactComponent };